import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModalModule, PoPageModule, PoWidgetModule, PoFieldModule, PoButtonModule, PoContainerModule, PoLoadingModule, PoTooltipModule, PoModalAction, PoSelectOption, PoDatepickerIsoFormat, PoBreadcrumbComponent, PoBreadcrumbModule, PoBreadcrumbItem } from '@po-ui/ng-components';
import { InventoryHeaderComponent } from './inventory-header/inventory-header.component';
import { InventoryCountDetailComponent } from './inventory-count/inventory-count-detail/inventory-count-detail.component';
import { InventoryCountComponent } from './inventory-count/inventory-count.component';
import { InventoryCountStepEnum } from '../../enums/inventory-count-step.enum';
import { InventoryModel } from '../../models/inventory.model';
import { ToasterComponent } from '../../shared/components/toaster/toaster.component';
import { InventoryCountModel } from '../../models/inventory-count.model';
import { StepBreadcrumbComponent, StepBreadcrumbItem } from '../../shared/components/step-breadcrumb/step-breadcrumb.component';

@Component({
  selector: 'app-inventory',
  animations: [
  ],
  imports: [FormsModule,
    PoModalModule,
    PoPageModule,
    PoWidgetModule,
    PoFieldModule,
    PoButtonModule,
    PoContainerModule,
    CommonModule,
    PoLoadingModule,
    PoTooltipModule,
    ReactiveFormsModule,
    FormsModule,
    InventoryHeaderComponent,
    InventoryCountComponent,
    InventoryCountDetailComponent,
    PoBreadcrumbModule,
    ToasterComponent,
    StepBreadcrumbComponent],
  templateUrl: './inventory.component.html',
  styleUrl: './inventory.component.css'
})
export class InventoryComponent implements OnInit, AfterViewInit {
  inventoryStep: InventoryCountStepEnum = InventoryCountStepEnum.InventoryHeader;
  InventoryCountStepEnum = InventoryCountStepEnum;
  inventoryModel!: InventoryModel;
  inventoryCountModel!: InventoryCountModel;
  isLoading: boolean = false;
  size = 'sm';
  text = 'Carregando';
  public readonly breadcrumbs: StepBreadcrumbItem[] = [
    { label: 'Lista de balanços' },
    { label: 'Contagens de balanço' },
    { label: 'Contagem' }
  ];

  constructor(private cdRef: ChangeDetectorRef) { }

  canExit(): boolean {
    switch (this.inventoryStep) {
      case InventoryCountStepEnum.InventoryHeader:
        return true;

      case InventoryCountStepEnum.InventoryCount:
        this.inventoryStep = InventoryCountStepEnum.InventoryHeader;
        return false;

      case InventoryCountStepEnum.InventoryCountDetail:
        this.inventoryStep = InventoryCountStepEnum.InventoryCount;
        return false;

      default:
        return true;
    }
  }

  ngOnInit(): void {
    history.pushState(null, '', location.href);
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    if (this.canExit()) {
      history.back();
    } else {
      history.pushState(null, '', location.href);
    }
  }

  navigateBreadcrumb({ item, index }: { item: StepBreadcrumbItem; index: number }) {
    this.inventoryStep = index;
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }

  onInventoryHeaderSelected(item: InventoryModel) {
    this.inventoryModel = item;

    this.nextStep();
  }

  onInventoryCountSelected(item: InventoryCountModel) {
    this.inventoryCountModel = item;

    this.nextStep();
  }

  onInventoryCountFinished() {
    this.inventoryStep = InventoryCountStepEnum.InventoryCount;
  }

  nextStep() {
    switch (this.inventoryStep) {
      case InventoryCountStepEnum.InventoryHeader:
        this.inventoryStep = InventoryCountStepEnum.InventoryCount;
        break;

      case InventoryCountStepEnum.InventoryCount:
        this.inventoryStep = InventoryCountStepEnum.InventoryCountDetail;
        break;

      default:
        this.inventoryStep = InventoryCountStepEnum.InventoryHeader;
    }
  }

  onLoadingChange(isLoading: boolean) {
    this.isLoading = isLoading;
    this.cdRef.detectChanges();
  }
}
